import {Trans} from "@lingui/react/macro";
import * as v from "valibot";
import {css} from "../../ui/Box";
import {TextAreaField, TextField} from "../form/fields";
import {useForm} from "../form/Form";

const recipeFormSchema = v.object({
  recipeName: v.pipe(v.string(), v.nonEmpty(), v.maxLength(256)),
  description: v.string(),
  defaultPortions: v.pipe(v.string(), v.regex(/^\d+$/, "Invalid number"), v.transform(Number)),
});

export type RecipeFormValues = v.InferOutput<typeof recipeFormSchema>;

export const RecipeForm = ({
  onSubmit,
  initial,
}: {
  onSubmit: (values: RecipeFormValues) => void;
  initial: v.InferInput<typeof recipeFormSchema>;
}) => {
  const {Form, field} = useForm({
    initial,
    schema: recipeFormSchema,
    onSubmit: onSubmit,
    submitOnBlur: true,
  });
  return (
    <Form className={css({display: "flex", flexDir: "column", sp: "16"})} buttonLabel={null}>
      <TextField field={field("recipeName")} label={<Trans>Name</Trans>} />
      <TextAreaField field={field("description")} label={<Trans>Steps</Trans>} />
      <TextField
        field={field("defaultPortions")}
        label={<Trans>Default Portions</Trans>}
        type="number"
        min="1"
      />
    </Form>
  );
};

const addRecipeFormSchema = v.object({
  recipeName: v.pipe(v.string(), v.nonEmpty(), v.maxLength(256)),
});

export const AddRecipeForm = ({onSubmit}: {onSubmit: (values: {recipeName: string}) => void}) => {
  const {Form, field} = useForm({
    initial: {recipeName: ""},
    schema: addRecipeFormSchema,
    onSubmit: onSubmit,
  });
  return (
    <Form className={css({display: "flex", flexDir: "column", sp: "16"})}>
      <TextField field={field("recipeName")} label={<Trans>Name</Trans>} data-drawer-autofocus />
    </Form>
  );
};
